module.exports = {
    topHead: {
        select_option_category: "Category",
        select_option_category_holder: "You can enter Title keywords or product links to search",
        select_option_brand: "Brand",
        select_option_brand_holder: "Please select",
        select_option_postKeyWords: "PostKeywords",
        select_option_postKeyWords_holder: "Please enter the content",
        rules_message_search: "Enter at least one brand or post content",
        my_attention: "MyAttention",
        login_label: "SignIn",
        login_out: "SignOut",
        Chinese: "中文",
        English: "English",
    },
};